import { PlatePluginOptions } from '@udecode/plate-core';

export const MARK_STRIKETHROUGH = 'strikethrough';

export const DEFAULTS_STRIKETHROUGH: Partial<PlatePluginOptions> = {
  hotkey: 'mod+shift+s',
};
